module.exports = require("core-js-pure/features/object/define-property");


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-react-components/node_modules/@babel/runtime-corejs3/core-js/object/define-property.js
// module id = 2126
// module chunks = 25